import {useDispatch} from 'react-redux';
import {deleteField} from '../service/createForm.slice';

export const useRemoveField = () => {
  const dispatch = useDispatch();
  const removeField = idx => {
    dispatch(deleteField(String(idx)));
  };
  return {
    removeField,
  };
};
